import {ApiClient} from "./config";

export const getCategoriesReq = async () => {
    return await ApiClient.get(`api/v1/assessment/category-list`);
}
export const generateQuizReq = async (data) => {
    return await ApiClient.post(`api/v1/assessment/${data?.id}/generate-test/`, data);
}
export const getQuestionsListReq = async (category, filterDate) => {
    return await ApiClient.get(`api/v1/assessment/question-list/${category}?period=${filterDate}`);
}
export const checkAnswerReq = async (data, id) => {
    return await ApiClient.post(`api/v1/assessment/quiz-evaluation/${id}/`, data);
}
export const uploadDocReq = async (data) => {
    return await ApiClient.post(`api/v1/document/upload/`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}
export const generateDocumentQuizReq = async (data, id) => {
    return await ApiClient.post(`api/v1/document/${id}/generate-test/`, data);
}
export const getPaymentReq = async () => {
    return await ApiClient.get(`api/v2/payment/prices/`);
}
export const paymentReq = async (data) => {
    return await ApiClient.post('payment/checkout/', data);
}
export const cancelSubscriptionReq = async () => {
    return await ApiClient.post('api/v1/subscriptions/cancel/');
}
export const pauseSubscriptionReq = async () => {
    return await ApiClient.post('api/v1/subscriptions/pause/');
}
export const resumeSubscriptionReq = async () => {
    return await ApiClient.post('api/v1/subscriptions/resume/');
}